import { getCurrentInstance } from 'vue';

export const useAppStore = () => {
    const vm = getCurrentInstance();
    if (vm) {
        return vm.proxy.$store;
    } else {
        return null;
    }
};
